export type CountryCode = 'AU' | 'NZ';

export type StoreCountryName = 'Australia' | 'New Zealand';

export type MultiTenancyHeader = 'x-jbg-country' | 'x-jbg-company';

export const getMultiTenancyHeaders = (countryCode: CountryCode): Record<MultiTenancyHeader, string> => {
  return { 'x-jbg-country': countryCode, 'x-jbg-company': 'JBH' };
};
